import React, { Component } from "react"
import { Col, Row, Tag } from "antd"
import { connect } from "react-redux"

import "asset/style/patient_folder.css"
import "asset/style/add_case.css"
import { getCaseIdPlaceholder } from "utils/org_utils"

class CaseInfo extends Component {
    render() {
        return (
            <Row type="flex" gutter={[0, 16]}>
                <Col span={24} className="col-div">
                    <div className="main-heading-wrapper">
                        <Row>
                            <Col span={2} className="main-heading">
                                <b>Details</b>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24} className="col-div detail-div">
                    <Row>
                        <Col span={4}>
                            <div>
                                <b>{getCaseIdPlaceholder()}:</b>
                            </div>
                            <div>
                                {this.props.folderName}
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <b>Created On:</b>
                            </div>
                            <div>
                                {(new Date(Date.parse(this.props.createdOn))).toDateString()}
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <b>Created By:</b>
                            </div>
                            <div>
                                {this.props.allUsers[this.props.createdBy]?.username}
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <b>Tags:</b>
                            </div>
                            <div style={{ display: "flex" }}>
                                {this.props.tags.map(t =>
                                    <Tag key={t}>{t}</Tag>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state) => ({
    allUsers: state.caseStatusReducer.users
})

export default connect(mapStateToProps)(CaseInfo)